import React from "react";

import { SubmitButton } from "../../../../../../components/boda-boda/Forms";
import { getOrdersItemsListAPI } from "../../../../../../config/boda-boda/apiUrls.config";
import { apiResponseStoringType } from "../../../../../../config/boda-boda/apiResponseKey";
import { getDataByFormObject } from "../../../../../../helpers/boda-boda/common-helpers/common.helpers";

const RemoveMessage = () => {
    return(
        <p>Are your sure you want to delete this item?</p>
    );
}

const RemoveBtn = (props) => {
    return(
        <SubmitButton
            btnText={"Yes"}
            elementStyle={"btn btn-primary waves-effect waves-light"}
            dataTableKey={getOrdersItemsListAPI.key}
            isValidate={false}
            flashMessages={{
                "success": {
                    status: true,
                    message: "Order item has successfully deleted",
                    type: "success"
                }
            }}
            callApiObject={{
                isSetHeaders: true,
                multipart: false,
                method: "delete",
                onUpload: false
            }}
            apiDataStoringObject={{
                setLoader: true,
                storingType: apiResponseStoringType.dateTableLinkedForm,
                mergeToSuccessResponse: null,
                mergeToErrorResponse: null,
            }}
            onGetAPIEndPointFn={(formObject) => {
                return {
                    url: `${getOrdersItemsListAPI.url}/${props.row.id}`,
                    key: getOrdersItemsListAPI.key
                }
            }}
            onChangeRequestBodyFn={(formObject) => {
                return getDataByFormObject(formObject);
            }}
            onResponseCallBackFn={(error, result) => {
                if (!error) {
                    props.setModelStatusFn(false);
                }
            }}
        />
    );
}

export {
    RemoveBtn,
    RemoveMessage
}
